import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18n from '../../../i18n';
import Analytics from '../../../utils/analytics';
import RequestApprovalPopupLayout from './RequestApprovalPopupLayout';
import Conversation from '../../../models/Conversation';
import User from '../../../models/User';

const ModificationRequesterCancelPopup = ({
    show,
    closeRequesterCancelModal,
    cancelModificationRequest,
    conversation,
    user
}) => {
    const [displayModal, setDisplayModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const closeModal = useCallback(() => {
        closeRequesterCancelModal();
    }, [closeRequesterCancelModal]);

    const cancel = useCallback(() => {
        setIsLoading(true);
        cancelModificationRequest().then(
            () => {
                Analytics.trackGTM(
                    'exchange_status',
                    {
                        event_data: {
                            exchange_status: 'finalized',
                            modification_status: 'cancelled',
                            exchange_type: conversation.isMutual()
                                ? 'reciprocal_exchange'
                                : 'guest_point_exchange',
                            collection: user.isCollection()
                        }
                    },
                    () => {
                        setIsLoading(false);
                        closeModal();
                        document.location.href = `${i18n.t('exchange:conversation.url', {
                            id: conversation.id
                        })}`;
                    }
                );
            },
            (error) => {
                setIsLoading(false);
                closeModal();
                console.error(`[ERROR: CANCEL MODIFICATION REQUEST]: ${error}`);
            }
        );
    }, [cancelModificationRequest]);

    const getReceiverName = () => {
        const modificator = conversation?.getSimpleExchangeModificator();
        return modificator?.get('update_requester') === modificator?.get('guest').get('id')
            ? modificator?.get('host').get('first_name')
            : modificator?.get('guest').get('first_name');
    };

    useEffect(() => {
        setDisplayModal(show);
    }, [show]);

    return (
        <RequestApprovalPopupLayout show={displayModal}>
            <div className="block-content">
                <div className="content-title">{i18n.t('messaging:are_you_sure')}</div>
                <div className="content-text">
                    {i18n.t('messaging:requester_cancels_modification_warning_modale', {
                        first_name: getReceiverName()
                    })}
                </div>
            </div>
            <div className="block-cta">
                <button
                    id="cancel-request-confirm"
                    className={classNames('hends-primary confirm btn-ajax', {
                        sending: isLoading
                    })}
                    onClick={cancel}
                >
                    {i18n.t('messaging:requester_cancels_modification_CTA_confirm_warning_modale')}
                </button>
                <button className="hends-secondary cancel" id="cancel-request-keep" onClick={closeModal}>
                    {i18n.t('messaging:requester_cancels_modification_CTA_cancel_warning_modale')}
                </button>
            </div>
        </RequestApprovalPopupLayout>
    );
};

ModificationRequesterCancelPopup.propTypes = {
    show: PropTypes.bool.isRequired,
    closeRequesterCancelModal: PropTypes.func.isRequired,
    cancelModificationRequest: PropTypes.func.isRequired,
    conversation: PropTypes.instanceOf(Conversation),
    user: PropTypes.instanceOf(User)
};

export default ModificationRequesterCancelPopup;
